export enum AutoEnrollmentSteps {
  BILLING_DATA = 1,
  STORE_DATA = 2,
  DOCUMENTATION = 3,
  SIGNATURE = 4,
  CONFIRMATION = 5,
}
